import Dispatcher from './Dispatcher';
import ActionTypes from './ActionTypes';
import JwtStore from './JwtStore'
import dispatchHttpError from '../utils/dispatchHttpError';

import checkStatus from '../utils/checkStatus';
import api from '../utils/api';

export default {
  saveActivity(activity, path = 'activities') {
    return fetch(api(path),{
      headers: {
        'Authorization': `Bearer ${JwtStore.getToken()}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      method: 'POST',
      body: JSON.stringify(activity),
    })
      .then(checkStatus)
      .then(response => response.json())
      .then(response => Dispatcher.dispatch({
        actionType: ActionTypes.ACTIVITY_SAVED,
        activity: response.data,
      }))
      .catch(dispatchHttpError);
  },

  saveActivityLog(data) {
    return this.saveActivity(data.params, data.path);
  }
}
